import(/* webpackMode: "eager", webpackExports: ["LoginForm"] */ "/app/apps/dashboard-app/app/(public)/login/form.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/packages/i11n/client/index.ts");
